'use strict'

var powers = 0

exports.boolean = increment()
exports.booleanish = increment()
exports.overloadedBoolean = increment()
exports.number = increment()
exports.spaceSeparated = increment()
exports.commaSeparated = increment()
exports.commaOrSpaceSeparated = increment()

function increment() {
  return Math.pow(2, ++powers)
}



//////////////////
// WEBPACK FOOTER
// ./~/rehype-react/~/property-information/lib/util/types.js
// module id = 119
// module chunks = 107818501498521